import React, {useEffect, useState} from 'react';
import {CheckMarkAnimation} from './CheckMarkAnimation';
import {useCartUI} from '@components/cart/CartSideCartUiProvider';
import {OutOfStockRouter} from '@components/preorders/out-of-stock-router.jsx';
import {useDatabaseCartProviderV3} from '@components/cart/CartProvider.jsx';
import {Spinner} from '@components/widgets/Common';
import {AddToCart_GA4} from '@components/datalayer/google';
import {usePreviousRoute} from '@helpers/hooks/usePreviousRoute';

export const AddToCartMobile = ({product}) => {
  const prevRoute = usePreviousRoute();

  const [isSuccessCount, setIsSuccessCount] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const [wasAdded, setWasAdded] = useState(false);

  const {toggleCart} = useCartUI();
  const {addToCart} = useDatabaseCartProviderV3();

  const sku = product?.sku;
  const isInStock = product?.currentlyInStock ?? product?.isInStock;

  let isOutOfStock = !isInStock;
  const isDiscontinued = product?.isDiscontinued === true;
  const tpaAndLvQtyCombinedRealOhTotal = (product?.tpa_wh ?? 0) + (product?.lv_wh ?? 0);
  const overRideStockWithRealQty = isDiscontinued && tpaAndLvQtyCombinedRealOhTotal > 0;
  // console.log('[AddToCartMobile] overRideStockWithRealQty: ', overRideStockWithRealQty);

  isOutOfStock = isOutOfStock && !overRideStockWithRealQty;

  useEffect(() => {
    if (wasAdded === true) {
      setTimeout(() => {
        setWasAdded(false);
      }, 1500);
    }
  }, [wasAdded]);

  useEffect(() => {
    if (isSuccessCount) {
      setIsSuccessCount(0);
    }
  }, [sku]);

  const addToCartHandler = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      let payload = {
        item: {
          sku: sku,
          quantity: 1,
          product_id: product?.id ?? product?.product_id,
          price: product?.price,
          price_map: product?.price_map ?? product?.priceMap,
          price_msrp: product?.price_msrp ?? product?.priceMsrp,
          price_dealer: product?.price_dealer ?? product?.priceDealer,
          source: 'product-page-button'
        }
      };
      setIsSuccessCount(isSuccessCount + 1);
      // console.log('[AddToCartMobile][payload]:', {payload})
      await addToCart(payload);
      AddToCart_GA4(payload);

      setLoading(false);
      setWasAdded(true);
      toggleCart();
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };
  // console.log('[AddToCartMobile][product]:', product);

  if (isOutOfStock) {
    return <OutOfStockRouter sku={sku} withQuantity={false} product={product} />;
  }

  return (
    <div className="mt-2">
      <AddToCartButtonMobileSimple
        isOutOfStock={isOutOfStock}
        isSuccess={wasAdded}
        isLoading={isLoading}
        onClick={addToCartHandler}
      />
      {isOutOfStock ? <p className="text-black text-center">Available in 2-3 weeks</p> : null}
    </div>
  );
};

export const AddToCartButtonMobileSimple = ({isOutOfStock, isSuccess, isLoading, onClick}) => {
  const disabledColor = 'rgb(209, 213, 219)';

  return (
    <button
      onClick={onClick}
      className="my-1 w-full rounded-lg py-3 text-center uppercase font-medium text-lg duration-700"
      disabled={isOutOfStock}
      style={
        isOutOfStock
          ? {
            boxShadow: 'none',
            backgroundColor: disabledColor,
            color: 'white'
          }
          : isSuccess
            ? {
              boxShadow: 'inset 0px 0px 0px 2px #26292B',
              backgroundColor: '#26292B',
              color: 'white'
            }
            : {
              boxShadow: 'none',
              backgroundColor: '#26292B',
              color: 'white'
            }
      }>
      {isLoading ? (
        <div className="flex flex-row justify-center items-center gap-1">
          <div className="w-8 h-6">
            <Spinner />
          </div>
          Add to Cart
        </div>
      ) : isSuccess ? (
        <div className="flex flex-row justify-center">
          <CheckMarkAnimation render={isSuccess} />
          Add to Cart
        </div>
      ) : isOutOfStock ? (
        'Out of stock'
      ) : (
        'Add to Cart'
      )}
    </button>
  );
};
